module.exports = __webpack_public_path__ + "img/about-5.f1d72227.png";